<template>
  <div>
    <van-dialog 
      :value="value" 
      :title="`${lessonUnit}数不足`" 
      @confirm="$emit('input', false)"
      >
      <div class="dialog-container">
        <div class="reserve_d1">
          学员的 “{{resCourse.curriculumName}}” {{lessonUnit}}数不足，请购买后再预约
        </div>
        <div class="reserve_d2">
          剩余可用{{lessonUnit}}数：{{reserveErrData.canUseAmount}}
          <van-icon
            name="question-o"
            size="var(--fs-sm)"
            style="vertical-align: text-top"
            @click="showStudentDialog()"
          />
        </div>
        <div class="reserve_d2">
          本次约课所需{{lessonUnit}}数：{{reserveErrData.useAmount}}
        </div>
      </div>
    </van-dialog>
    <!-- 学员课时弹窗 -->
    <van-dialog v-model="showStudentAmountDialog" confirmButtonText="我知道了"  >
      <div class="student-amount-dialog">
        <div class="student-amount-title">当前剩余数量：</div>
        <div  class="student-amount-item">
          <div class="name">
            <span class="tag" :class="{'card':reserveErrData.cardType == 1}">{{reserveErrData.cardType == 0 ? '课程' : '课时包'}}</span>{{reserveErrData.cardName}}
          </div>
          <div class="amount"><span class="label">剩余：</span>{{reserveErrData.remainAmount}}</div>
        </div>
        <div class="student-amount-title" v-if="reserveErrData.reserveRecords!==null">已约课次：</div>
        <div v-for="(ele,idx) in Object.keys(reserveErrData.reserveRecords || {})" :key="idx" class="student-amount-item">
          <div class="name">
            {{ele}}
          </div>
          <div class="amount"><span class="label">预占：</span>{{reserveErrData.reserveRecords[ele]}}</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>

export default ({
  props:{
    value: {
      type: Boolean,
      default: false,
    },
    reserveErrData:{
      type: [Object, String],
    },
    resCourse: {
      type: [Object, String],
    },
  },
  data () {
    return {
      showStudentAmountDialog: false,
      currentStudentAmount: [{"cardInfoId":1711076,"cardType":1,"name":"创意美术","remainAmount":1}],
    }
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
  },
  methods: {
    showStudentDialog () {
      this.$emit('input', false);
      this.showStudentAmountDialog = true;
    },
  }
})
</script>
<style lang="scss" scoped>
.dialog-container{
  text-align: center;
  padding: calc(var(--gap) * 8) calc(var(--gap) * 24) calc(var(--gap) * 26);

  .reserve_d1,
  .reserve_d2 {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--g6);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    i{
      margin-left: calc(var(--gap) * 2);
    }
  }
  .reserve_d1 {
    margin-bottom: calc(var(--gap) * 30);
  }
}
.student-amount-dialog {
  font-size:var(--fs-md);
  line-height:var(--lh-md);
  padding: calc(var(--gap) * 6) calc(var(--gap) * 16);
  .student-amount-title {
    padding: calc(var(--gap) * 12) 0;
  }
  .student-amount-item {
    padding: calc(var(--gap) * 4) 0;
    display: flex;
    justify-content: space-between;
    .name {
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      .tag {
        margin-right: calc(var(--gap) * 4);
        display: inline-block;
        font-weight: normal;
        padding: 0 calc(var(--gap) * 2);
        color: var(--white);
        background: var(--c1);
        border-radius: 2px;
        &.card {
          background-color: var(--c4);
        }
      }
    }
    .amount {
      margin-left: calc(var(--gap) * 4);
      flex-shrink: 0;
      .label {
        color: var(--g6);
      }
    }
  }
}
</style>